import React from "react";
import AMPReport from "assets/images/AMP-report.png";
import AmpIcon from "assets/svgIcons/AdminDashboard/AmpHrIcon";
import { useTranslation } from "react-i18next";
export const AmpHrReport = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="header">
        <AmpIcon />
        <p className="green-border">{t("AMP_HR_Report")}</p>
      </div>
      <div className="box-body ">
        <div className="amr-report-section">
          <img src={AMPReport} alt="pace-report" />
          <p>{t("Amp_Hours")}</p>
        </div>
      </div>
    </>
  );
};
